import { MetaConversionsApiClient } from '@fourthwall/services/dist/MetaConversionsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useGetMetaConversionQuery = createQueryHook(MetaConversionsApiClient.getPixel, {
  queryKey: ['metaConversion'],
})
